import type { TestStatus, VisitFacts } from '../api/patientSummary'

// Pure (no api/axios imports) so the print document and its tests can use it without the app's alias chain.

/** The facts belong to an admitted patient's discharge instructions rather than an outpatient visit summary
 * (docs/superpowers/specs/2026-10-01-inpatient-patient-instructions-design.md). */
export const isInpatientFacts = (facts?: VisitFacts | null): boolean => facts?.variant === 'inpatient'

/** The facts' tests with their status — null for a summary completed before tests carried one (names only). */
export const visitTests = (facts?: VisitFacts | null): Array<{ name: string; status: TestStatus | null }> =>
  (facts?.tests ?? []).map(test => (typeof test === 'string' ? { name: test, status: null } : test))
